module.exports = __webpack_public_path__ + "img/deposit@2x.3652eb16.png";